<template>
    <label :class="[$style['mds-radio-button'], classObject, sizeClass]" :data-mds-version="version">
        <input
            v-bind="$attrs"
            :name="name"
            :value="value"
            type="radio"
            :class="$style['mds-radio-button__input']"
            :checked="isChecked"
            :disabled="disabled"
            @change="toggleCheck($event)"
        />
        <span :class="$style['mds-radio-button__visible-wrap']">
            <span :class="$style['mds-radio-button__visual']"></span>
            <span :class="$style['mds-radio-button__text']">
                <slot>{{ label }}</slot>
                <span v-if="microcopy" :class="$style['mds-radio-button__microcopy']" v-html="microcopy"></span>
            </span>
        </span>
    </label>
</template>

<script>
    // Import component's API
    import MdsRadioButtonProps from './radio-button_props.js';

    export default {
        name: 'MdsRadioButton',
        inheritAttrs: false,
        model: {
            prop: 'modelValue',
            event: 'input',
        },
        props: MdsRadioButtonProps,
        computed: {
            sizeClass() {
                return this.$style[`mds-radio-button--${this.size}`];
            },
            classObject() {
                const obj = {};
                obj[this.$style['mds-component--on-dark']] = this.onDark;

                return obj;
            },
            isChecked() {
                return this.modelValue === undefined ? this.checked : this.modelValue === this.value;
            },
        },
        methods: {
            toggleCheck(event) {
                this.$emit('input', this.isChecked ? '' : this.value, event);
            },
        },
        watch: {
            checked(newValue) {
                if (newValue !== this.isChecked) {
                    this.toggleCheck();
                }
            },
        },
    };
</script>

<style lang="scss" module>
    @import './radio-button.scss';
</style>
